/* AUTO-GENERATED. Do not edit by hand. */

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import type { RemixiconComponentType } from '../types'

/**
 * RiFullscreenLine icon component from Remix Icon set.
 * 
 * @param props - RemixiconProps
 * @returns JSX element representing the RiFullscreenLine icon
 */
const RiFullscreenLine: RemixiconComponentType = (props): JSX.Element => {
  // Extract RemixiconProps
  const {
    color = 'currentColor',
    size = 24,
    ...rest
  } = props

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      fill={color}
      width={size}
      height={size}
      {...rest}
    >
      <path fill="currentColor" d="M8 3v2H4v4H2V3zM2 21v-6h2v4h4v2zm20 0h-6v-2h4v-4h2zm0-12h-2V5h-4V3h6z"/>
    </svg>
  )
}

export default RiFullscreenLine
